/**
 * "Check manually" pages: OCR could not read enough text on the page (below
 * the minimum after both OCR passes). The tagger found little or nothing
 * there, so the page looks clean without being checked. It is flagged per
 * page (`PageRo.needsManualCheck`) and is never counted as clean.
 */
import type { PageRo } from 'src/app/services/api.generated';

type MaybeFlagged = Pick<PageRo, 'needsManualCheck'> | null | undefined;

/** Old tasks have no field: not flagged. */
export const needsManualCheck = (page: MaybeFlagged): boolean =>
  !!page?.needsManualCheck;

/** 0-based indexes of the flagged pages. */
export const manualCheckPageIndexes = (pages: MaybeFlagged[]): number[] =>
  pages.flatMap((page, index) => (needsManualCheck(page) ? [index] : []));

/** Cached count on a task row. Absent means 0. */
export const manualCheckPagesOf = (task: { manualCheckPages?: number }) =>
  Math.max(0, Number(task.manualCheckPages) || 0);

/** i18n keys (public/locales/{nl,en,de}/common.json). */
export const MANUAL_CHECK_KEYS = {
  label: 'manualCheck.label',
  explanation: 'manualCheck.explanation',
  listChip: 'manualCheck.listChip',
  exportWarning: 'manualCheck.exportWarning',
} as const;
